import { Code, Flex, Title } from '@mantine/core';
import { useEffect, useState } from 'react';

import { Declaration } from '@e-origin/shared';

import { DECLARATION_VIEW_PROOF_JSON_INDENT } from '@constants';
import classes from './DeclarationViewCustomsProof.module.css';

interface DeclarationViewCustomsProofProps {
  status?: string;
  declaration: Declaration;
}

export const DeclarationViewCustomsProof: React.FC<DeclarationViewCustomsProofProps> = ({ declaration }) => {
  const [proof, setProof] = useState(null);

  useEffect(() => {
    if (declaration?.customsProof?.decodedProof) {
      setProof(JSON.stringify(declaration?.customsProof?.decodedProof, null, DECLARATION_VIEW_PROOF_JSON_INDENT));
    }
  }, [declaration]);

  return (
    <Flex direction={'column'} h="100%">
      <Title order={2} fw={500} my={10} fz={24}>
        Proof
      </Title>
      {proof ? <Code block>{proof}</Code> : <p>No proof generated!</p>}
    </Flex>
  );
};
